import type { WorkspaceProjection } from '@localagent/sdk';
import { WorkspaceReadiness } from './WorkspaceReadiness';
import { WorkspaceResourceCards } from './WorkspaceResourceCards';

function searchSummary(projection: WorkspaceProjection): string {
  const { index } = projection;
  if (index.health === 'degraded') return 'Some files could not be indexed';
  if (index.progress === 'indexing') return `Indexing (${index.indexed} files so far)`;
  return `${index.indexed} files searchable`;
}

export function WorkspaceOverviewSummary({ projection }: { projection: WorkspaceProjection }) {
  const local = projection.assignment.routing_class === 'local';
  const folder = projection.binding?.folder_path;

  return (
    <section data-testid="workspace-overview-summary">
      <article className="rounded-lg bg-card p-4">
        <dl className="grid grid-cols-[8rem_1fr] gap-x-4 gap-y-2 text-body">
          <dt className="text-muted-foreground">Status</dt>
          <dd>
            <WorkspaceReadiness projection={projection} />
          </dd>
          <dt className="text-muted-foreground">Location</dt>
          <dd>{local ? 'On this computer' : 'In the cloud'}</dd>
          {folder && (
            <>
              <dt className="text-muted-foreground">Folder</dt>
              <dd className="truncate font-mono text-caption">{folder}</dd>
            </>
          )}
          <dt className="text-muted-foreground">Search</dt>
          <dd data-testid="workspace-overview-search">{searchSummary(projection)}</dd>
          <dt className="text-muted-foreground">Created</dt>
          <dd>{new Date(projection.created_at).toLocaleDateString()}</dd>
        </dl>
      </article>
      <WorkspaceResourceCards projection={projection} />
    </section>
  );
}
